import React, { useState, useEffect } from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Chip,
  Grid,
  Box,
  Avatar,
  Fade,
  IconButton,
  LinearProgress,
  useMediaQuery,
  useTheme,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import storyImg from './story.png';
import trendingImg from './trendingImg.png';
import { ArrowBackIosNewRounded, KeyboardDoubleArrowUp } from '@mui/icons-material';
import swipeup from './swipeup.gif';
import { variants } from '../../../variants/variants';
import { empty } from '../../Gift/assets/index';
import defaultImage from './default.png';

const NewsCarousel = ({ currentIndex, setCurrentIndex, topNews, isLoading, isError, isTopNews, isSm,handleCloseCarousel }) => {
  const navigate = useNavigate();
  const [progressValues, setProgressValues] = useState(Array.from({ length: 4 }).fill(0));
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (!isLoading && topNews) {
      setCurrentIndex(0); // Reset to the first news item when data is loaded
    }
  }, [isLoading, topNews]);

  if (isLoading) {
    return <Card sx={{ position: 'relative', overflow: 'hidden' }}>{/ Skeleton loading UI /}</Card>;
  }

  if (isError) {
    return <Typography>Error fetching news data.</Typography>;
  }

  if (!topNews || topNews.length === 0) {
    // Display "No data found" when topNews is empty
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '92vh',
          backgroundColor: 'black',
          color: 'white',
          textAlign: 'center',
        }}
      >
        <img style={{ width: '50%' }} src={empty} alt="pending" />
        <Typography sx={{ fontSize: variants.TINY, p: 2, color: 'lightgrey' }}>No Featured News</Typography>
      </Box>
    );
  }
  console.log('isSm', isSmallScreen);
  const handleCardClick = (id) => {
    navigate(`${id}`);
  };

  const handleNext = () => {
    if (topNews && currentIndex < topNews.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (topNews && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleViewMore = () => {
    handleCloseCarousel()
    navigate(`/home/announcement/gnn/${topNews[currentIndex]?._id}`);
  };

  const chipsStyle = {
    position: 'absolute',
    top: 5,
    zIndex: 2,
    background: 'none',
    backgroundSize: '200% 200%',
    animation: 'gradientAnimation 4s ease infinite',
    borderRadius: '0',
  };

  return isSmallScreen ? (
    <Box
      xs={12}
      sm={12}
      sx={{
        borderRadius: 0,
        width: '100%',
        height: '100%',
        position: 'absolute',
        zIndex: '100000',
        backgroundColor: 'black',
      }}
    >
      <Fade in={true} timeout={500} mountOnEnter unmountOnExit>
        <Grid
          sx={{
            border: 'none',
            borderRadius: 0,
            backgroundColor: 'black',
            position: 'absolute',
            bottom: 0,
            top: 0,
            left: 0,
            right: 0,
            zIndex: '1000',
            width: '100%',
            height: '100%',
            backgroundColor: 'black',
          }}
        >
          <Card
            sx={{
              border: 'none',
              borderRadius: 0,
              backgroundColor: 'black',
              position: 'relative',
              overflow: 'hidden',
              cursor: 'default',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '80vh',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '50%',
                height: '100%',
                zIndex: 2,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '50%',
                height: '100%',
                zIndex: 2,
              }}
            />

            <CardMedia
              component="img"
              image={`${process.env.REACT_APP_PUBLIC_UPLOADS_URL}${topNews[currentIndex]?.attachments[0]}`}
              alt={topNews[currentIndex]?.title}
              onError={(e) => {
                e.target.onerror = null; // prevent infinite loop if default also fails
                e.target.src = defaultImage; // fallback image path
              }}
              sx={{
                width: { xs: 'auto', sm: 'auto', md: 'auto' },
                height: 'auto',
                maxWidth: '100%',
              }}
            />

            <CardContent
              sx={{
                border: 'none',
                borderRadius: 0,
                backgroundColor: 'black',
                position: 'absolute',
                top: 2,
                left: 0,
                right: 0,
                textAlign: 'center',
                zIndex: 1,
                padding: { xs: '2.5rem', sm: '2.5rem', md: '2rem' },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mt: 5,
                  color: 'black',
                  fontWeight: 'bold',
                  fontSize: { xs: '1rem', sm: '1.75rem', md: '2rem' },
                }}
              >
                {topNews[currentIndex]?.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: '0.75rem', sm: '1.50rem', md: '1.75rem' },
                  color: 'black',
                }}
              >
                {topNews[currentIndex]?.categories.join(', ')}
              </Typography>
            </CardContent>
          </Card>
          <Grid
            sx={{
              position: 'fixed', // Fix the position
              bottom: '16px', // Position from the bottom
              left: '50%', // Center horizontally
              transform: 'translateX(-50%)', // Adjust to truly center
              backgroundColor: 'black',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              textAlign: 'center',
              padding: '8px 16px', // Adjust padding as needed
              borderRadius: '8px', // Optional: for rounded corners
              display: 'flex', // Flex display for alignment
            }}
          >
            <Typography sx={{ color: 'white', mr: 1 }}>
              <KeyboardDoubleArrowUp />
            </Typography>
            <Typography sx={{ color: 'white' }}>Swipe to Read More</Typography>
          </Grid>
        </Grid>
      </Fade>
    </Box>
  ) : (
    <Box
      xs={12}
      sm={12}
      sx={
        {
          // borderRadius: 0,
          // width: '100%',
          // height: '100%',
          // position: 'absolute',
          // zIndex: '100000',
          // backgroundColor: 'black',
        }
      }
    >
      {/* <Fade in={true} timeout={500} mountOnEnter unmountOnExit> */}
      <Grid
        sx={{
          border: 'none',
          borderRadius: 0,
          // backgroundColor: 'black',
          // position: 'absolute',
          // bottom: 0,
          // top: 0,
          // left: 0,
          // right: 0,
          // zIndex: '1000',
          // width: '100%',
          // height: '100%',
          // backgroundColor: 'black',
        }}
      >
        <Card
          sx={{
            border: 'none',
            borderRadius: 0,
            backgroundColor: 'black',
            position: 'relative',
            overflow: 'hidden',
            cursor: 'default',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '80vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            // marginTop: '5rem',
          }}
        >
          {/* <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '50%',
                height: '100%',
                zIndex: 2,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '50%',
                height: '100%',
                zIndex: 2,
              }}
            /> */}

          <CardMedia
            component="img"
            image={`${process.env.REACT_APP_PUBLIC_UPLOADS_URL}${topNews[currentIndex]?.attachments[0]}`}
            alt={topNews[currentIndex]?.title}
            onError={(e) => {
              e.target.onerror = null; // prevent infinite loop if default also fails
              e.target.src = defaultImage; // fallback image path
            }}
            sx={{
              width: { xs: 'auto', sm: 'auto', md: '90%' },
              height: 'auto',
              maxWidth: '100%',
            }}
          />

          {/* <CardContent
              sx={{
                border: 'none',
                borderRadius: 0,
                // backgroundColor: 'black',
                position: 'absolute',
                top: 2,
                left: 0,
                right: 0,
                textAlign: 'center',
                zIndex: 1,
                padding: { xs: '2.5rem', sm: '2.5rem', md: '2rem' },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mt: 5,
                  color: 'black',
                  fontWeight: 'bold',
                  fontSize: { xs: '1rem', sm: '1.75rem', md: '2rem' },
                }}
              >
                {topNews[currentIndex]?.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: { xs: '0.75rem', sm: '1.50rem', md: '1.75rem' },
                  color: 'black',
                }}
              >
                {topNews[currentIndex]?.categories.join(', ')}
              </Typography>
            </CardContent> */}
        <Grid>
          <Button variant="contained" onClick={handleViewMore}>View More</Button>
        </Grid>
        </Card>
        {/* <Grid
            sx={{
              position: 'fixed', // Fix the position
              bottom: '16px', // Position from the bottom
              left: '50%', // Center horizontally
              transform: 'translateX(-50%)', // Adjust to truly center
              backgroundColor: 'black',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              textAlign: 'center',
              padding: '8px 16px', // Adjust padding as needed
              borderRadius: '8px', // Optional: for rounded corners
              display: 'flex', // Flex display for alignment
            }}
          >
            <Typography sx={{ color: 'white', mr: 1 }}>
              <KeyboardDoubleArrowUp />
            </Typography>
            <Typography sx={{ color: 'white' }}>Swipe to Read More</Typography>
          </Grid> */}
      </Grid>
      {/* </Fade> */}
    </Box>
  );
};

export default NewsCarousel;
